var map = {
	"./celery.svg": 66620,
	"./crustaceans.svg": 1278,
	"./egg.svg": 39649,
	"./fish.svg": 27933,
	"./gluten.svg": 65803,
	"./lactose.svg": 76618,
	"./lupin.svg": 26757,
	"./mollusques.svg": 30378,
	"./mustard.svg": 60658,
	"./peanut.svg": 45203,
	"./sesame.svg": 42185,
	"./shelledFruits.svg": 54573,
	"./soy.svg": 52415,
	"./sulphites.svg": 79174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72898;